import React from 'react';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import { translate } from '../../../i18n/I18nProvider';

const ActionsButtons = ({
  onCloseClick,
  handleSubmit,
  handleSaveAndClose,
  dirty,
  fromTelepoUser = true
}) => {
  return (
    <>
      <SecondaryButton onClick={onCloseClick}>
        {translate('BUTTON.CANCEL')}
      </SecondaryButton>
      {!fromTelepoUser && (
        <PrimaryButton onClick={handleSubmit} disabled={!dirty}>
          {translate('BUTTON.SAVE')}
        </PrimaryButton>
      )}
      {fromTelepoUser && (
        <SecondaryButton onClick={handleSubmit} disabled={!dirty}>
          {translate('BUTTON.SAVE')}
        </SecondaryButton>
      )}
      {fromTelepoUser && (
        <PrimaryButton
          onClick={handleSaveAndClose || handleSubmit}
          disabled={!dirty}
        >
          {translate('BUTTON.SAVE_AND_CLOSE')}
        </PrimaryButton>
      )}
    </>
  );
};

export default ActionsButtons;
